import { PageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import pageManagerConfigurationBase from "./PageManagerConfigurationBase.Generated";

const
    configuration: PageManagerConfiguration = {
        detailsPageMap: {
            ...pageManagerConfigurationBase.detailsPageMap,
            "OfficerRequest": async () => (await import("./Pages/Entities/OfficerRequests/OfficerRequestDetailsPage")).OfficerRequestDetailsPage,
        },
        indexPageMap: {
            ...pageManagerConfigurationBase.indexPageMap,
        },
        routes: {
            ...pageManagerConfigurationBase.routes,
            "/": async () => (await import("./Pages/Entities/OfficerRequests/OfficerRequestIndexPage.Generated")).OfficerRequestIndexPage,
            "/login/": async () => (await import("@seriously-rad/seriouslyrad-framework-core/Ui/Pages/LoginPage")).LoginPage,
        }
    };

export default configuration;